import { useLazyQuery } from "@apollo/client";
import { ACC_COMPANY_CHANNELS } from "components/gql/gql_queries_acc";
import { GetChannels } from "contexts/ChannelsContext";
import { GetCInfo } from "contexts/CompanyContext";

import {
  consoleBeauty,
  isIdentical,
  isObjectEmpty,
  logGQLError,
} from "data/functions";

export function GetChannelsQuery() {
  const queryName = "GetChannels";
  const { cInfo, setCInfo } = GetCInfo();
  const { addChannels, channels, setParam } = GetChannels();
  const [refetch, variables] = useLazyQuery(ACC_COMPANY_CHANNELS, {
    fetchPolicy: "no-cache",

    onCompleted: (data) => {
      if (isObjectEmpty(data.acc_getCompanyChannels)) {
        setCInfo([], "channels");
        addChannels([]);
        // setParam("statuses", {});
      } else {
        consoleBeauty("Получен список каналов", "GraphQL", "darkgreen");
        if (!isIdentical(data.acc_getCompanyChannels, channels)) {
          addChannels(data.acc_getCompanyChannels);
        }
        if (!isIdentical(data.acc_getCompanyChannels, cInfo?.channels)) {
          setCInfo(data.acc_getCompanyChannels, "channels");
        }
      }
    },
    onError: (e) => {
      setCInfo([], "channels");
      addChannels([]);
      logGQLError(queryName, e);
    },
  });
  return [refetch, variables];
}
